import { Attr, BelongsTo, Model } from "spraypaint";

import {
  ApplicationRecord,
  objectDirtyChecker,
} from "shared/services/spraypaint";

import type Organisation from "./Organisation";

@Model()
class ContentLicense extends ApplicationRecord {
  static jsonapiType = "content_licenses";

  @Attr({ dirtyChecker: objectDirtyChecker }) access: string[];

  @Attr() agencyContact: string;

  @Attr() excludeFromReporting: boolean;

  @Attr() externalOrgId: string;

  @Attr() externalOrgName: string;

  @Attr() externalSource: string;

  @Attr() externalSourceId: string;

  @Attr() isAllowed: boolean;

  @Attr() licenseType: string;

  @BelongsTo() organisation: Organisation;

  @Attr() serviceEndDate: string;

  @Attr() serviceStartDate: string;

  @Attr() serviceStatus: string;
}

export default ContentLicense;
